const combineConnectors = connectors => Component => {
	return connectors.reduce((WrappedComponent, connect) => {
		return connect(WrappedComponent);
	}, Component);
};

export default combineConnectors;
